import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IdService {
  private mostrarOrigemIdSubject = new BehaviorSubject<boolean>(false);
  public mostrarOrigemId$ = this.mostrarOrigemIdSubject.asObservable();

  public get mostrarOrigemId(): boolean {
    return this.mostrarOrigemIdSubject.value;
  }

  public alterarVisualizacao(): void {
    const novoEstado = !this.mostrarOrigemIdSubject.value;
    this.mostrarOrigemIdSubject.next(novoEstado);
  }

  public alternarColunaGlobal(): string {
    return this.mostrarOrigemId ? 'Origem Id' : 'Id';
  }
}
